<template>
    <div>
        <button type="submit" class="btn btn-dark btn-lg btn-block" v-on:click="logOut()"> 登出 </button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: '',
                username: '',
                password: '',
                password_confirmation: '',
            }
        },
        methods: {
            logOut: function() {
                axios
                    .post(base_url + '/admin/api/logout')
                    .then((response) => {
                        if (response.data.message == "Logout success.") {
                            Turbolinks.visit(base_url + '/admin/');
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        }
    }
</script>